import './antTooltip.less';

import React from 'react';
import { observer } from 'mobx-react';
import { Tooltip, TooltipProps } from 'antd';
import classnames from 'classnames';
import b_ from 'b_';

export type AntTooltipProps = Omit<
	TooltipProps,
	'overlayClassName' | 'overlayStyle' | 'overlayInnerStyle' | 'destroyTooltipOnHide'
> & {
	enabled?: boolean;
};

const b = b_.with('ant-tooltip-wrapper');

export const AntTooltip = observer((props: AntTooltipProps) => {
	const { enabled, rootClassName, ...rest } = props;

	return <Tooltip rootClassName={classnames(rootClassName, b())} {...rest} />;
});
